import React, { useState, useEffect, useRef } from "react";
import { ViewsReportContainer } from "./_viewsReport.styled";
import { Statistic, Row, Col, Button, Spin } from "antd";
import moment from "moment";
import { httpGet } from "../../utils/https";
import { LoadingOutlined } from "@ant-design/icons";
import DemoColumn from "./bar_chart/barChart";
import ViewsTable from "./table/table";
import HeatMap from "../../component/heat-map";
import DateRangePickerFilter from "../../component/date-range-picker-filter";
import { URLS } from "../../utils/urls";
import * as XLSX from 'xlsx';


function ViewsReport({
  dateString,
  adServingLogs,
  viewsHeatMapDataLoading,
  selectedCampaign,
  viewsHeatMapLatLong,
  viewsCount,
  selectedCampaignData,
  onDatePickerChange,
  datePickerError,
  campaignId,
  dateChangeTracker,
  resetMapStyle,
}) {
  const [showDetails, setShowDetails] = useState(true);
  const startDate = dateString && dateString[0];
  const endDate = dateString && dateString[1];
  const [spotsDetails, setSpotsDetails] = useState();
  const [spotsCounts, setSpotsCounts] = useState();
  const [totalItems, setTotalItems] = useState();
  const [spotsGraph, setSpotsGraph] = useState([]);
  const [statsLoadingTracker, setStatsLoadingTracker] = useState(false);
  const [chartLoadingTracker, setChartLoadingTracker] = useState(false);
  const [tableLoadingTracker, setTableLoadingTracker] = useState(false);
  const [chartDownloadData, setChartDownloadData] = useState();
  const [exportData, setExportData] = useState([])
  const [geoJsonLink, setGeoJsonLink] = useState(null)
  const [isLoading, setIsLoading] = useState(false)


  useEffect(() => {
    // deliveredCampaignApi();
    getSpotsMapsData();
  }, [campaignId, dateChangeTracker]);

  const getSpotsMapsData = () => {
    setIsLoading(true)

    let queryParams = new URLSearchParams()
    queryParams.append('campaign_id', campaignId)
    queryParams.append('limit', 1000000)

    let url = `${URLS?.SPOTS?.GET_HEATMAP_DATA}?${queryParams.toString()}`

    httpGet(url)
      .then((res) => {
        setGeoJsonLink(res?.data)
        setIsLoading(false)
      }).catch((err) => [
        setIsLoading(false)
      ])
  }

  useEffect(() => {
    let url = `${URLS?.CAMPAIGNS?.GET_USER_CAMPAIGN_DETAILS.replace(
      "#CAMPAIGN_ID#",
      campaignId
    )}`;

    if (campaignId) {
      setStatsLoadingTracker(true);
      httpGet(url)
        .then((res) => {
          if (res?.status == 200) {
            setSpotsCounts(res?.data);
          } else {
            setSpotsCounts([]);
          }
          setStatsLoadingTracker(false);
        })
        .catch((err) => {
          setStatsLoadingTracker(false);
        });
    }
  }, [campaignId]);

  useEffect(() => {

    const newStartDate = moment.utc(startDate).startOf("day").unix();
    const newEndDate = moment.utc(endDate).startOf("day").unix();

    const queryParams = new URLSearchParams();
    if (newStartDate) queryParams.append("startDate", newStartDate);
    if (newEndDate) queryParams.append("endDate", newEndDate);
    let url = `${URLS?.SPOTS?.GET_CAMPAIGN_SPOT_DETAILS.replace(
      "#CAMPAIGN_ID#",
      campaignId
    )}?${queryParams.toString()}`;

    console.log("campaignId && dateChangeTracker > 0", campaignId && dateChangeTracker > 0)

    if (campaignId) {

      setChartLoadingTracker(true);
      httpGet(url)
        .then((res) => {
          if (res?.status == 200) {
            const apiData = res?.data?.daily_counts || [];
            const paddedData = [];
            let current = moment.utc(startDate).startOf("day");
            const end = moment.utc(endDate).startOf("day");

            while (current.isSameOrBefore(end)) {
              const dateStr = current.format("DD-MM-YYYY");
              const matchingEntry = apiData.find(item => item.served_date_formatted === dateStr);

              paddedData.push({
                date: current.valueOf(),
                count: matchingEntry ? matchingEntry.spots_count : 0
              });
              current.add(1, 'days');
            }

            setSpotsGraph(paddedData);
            setExportData(paddedData);
          } else {
            setSpotsGraph([]);
          }
          setChartLoadingTracker(false);
        })
        .catch((err) => {
          setChartLoadingTracker(false);
        });
    }
  }, [campaignId, dateChangeTracker]);

  // const deliveredCampaignApi = (page, pageSize) => {
  //   const newStartDate = moment.utc(startDate).startOf("day").unix();
  //   const newEndDate = moment.utc(endDate).startOf("day").unix();

  //   const queryParams = new URLSearchParams();
  //   queryParams.append("campaign_id", campaignId);
  //   queryParams.append("start_date", newStartDate);
  //   queryParams.append("end_date", newEndDate);
  //   queryParams.append("page", page ? page : 1);
  //   queryParams.append("pageSize", pageSize ? pageSize : 20);

  //   let url = `${URLS?.SPOTS?.GET_CAMPAIGN_SPOTS_LIST}?${queryParams.toString()}`;

  //   if (campaignId) {
  //     setTableLoadingTracker(true);
  //     httpGet(url)
  //       .then((res) => {
  //         if (res?.status == 200) {
  //           setSpotsDetails(res?.data);
  //           setTotalItems(res?.totalItems);
  //         }
  //         setTableLoadingTracker(false);
  //       })
  //       .catch((err) => {
  //         setTableLoadingTracker(false);
  //       });
  //   }
  // };

  const downloadChart = () => {
    const transformedData = exportData.map(item => ({
      Date: item.date,
      'Spots Count': item.count
    }));

    const worksheet = XLSX.utils.json_to_sheet(transformedData);

    // Create a new workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Generate a binary string of the workbook
    const workbookBinary = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });

    // Convert the binary string to an array buffer
    const buffer = new ArrayBuffer(workbookBinary.length);
    const view = new Uint8Array(buffer);
    for (let i = 0; i < workbookBinary.length; i++) {
      view[i] = workbookBinary.charCodeAt(i) & 0xFF;
    }

    // Create a Blob from the array buffer and download it
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `report_spots_count_${campaignId}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  return (
    <ViewsReportContainer>
      <div className="container">
        <div style={{ height: "100%", width: "100%" }} className="mt-5">

          <HeatMap
            selectedCampaignData={selectedCampaignData}
            campaignId={campaignId}
            resetMapStyle={resetMapStyle}
            geoJsonLink={geoJsonLink}
            loading={isLoading}
          />
          {selectedCampaignData &&
            selectedCampaignData[0] &&
            selectedCampaignData[0].campaign_start_date &&
            selectedCampaignData[0].campaign_end_date && (
              <div className="mapDateLabel mt-3 w-100 text-center d-flex justify-content-around">
                {selectedCampaignData[0].campaign_start_date &&
                  selectedCampaignData[0].campaign_end_date &&
                  selectedCampaignData[0].last_sync_date ? (
                  <>
                    <label>
                      {"From Date: "}
                      {moment(selectedCampaignData[0].campaign_start_date, [
                        "YYYY-MM-D HH:mm:ss",
                      ]).format("MMM D YYYY hh:mm A")}
                    </label>
                    <label>
                      {"To Date: "}
                      {moment(
                        selectedCampaignData[0].campaign_end_date
                      ).isAfter(moment(new Date()).format("YYYY-MM-DD"))
                        ? moment(
                          selectedCampaignData[0]?.last_sync_date ||
                          new Date(),
                          ["YYYY-MM-D HH:mm:ss"]
                        ).format("MMM D YYYY hh:mm A")
                        : moment(selectedCampaignData[0].campaign_end_date, [
                          "YYYY-MM-D HH:mm:ss",
                        ]).format("MMM D YYYY hh:mm A")}
                    </label>
                  </>
                ) : (
                  <label>
                    {
                      "Note: Data will be available after the 24 hours of creating the Campaign."
                    }
                  </label>
                )}
              </div>
            )}
        </div>
        <div className="numberData">
          <Row
            gutter={[{ xs: 64, sm: 86, md: 128, lg: 256 }, 24]}
            justify="center"
          >
            <Col
              xs={12}
              sm={12}
              md={12}
              className="d-flex flex-column align-items-center"
            >
              <Statistic
                title="Today's Spots"
                value={spotsCounts?.today_served_spot}
                loading={statsLoadingTracker}
                responsive={{
                  xs: { fontSize: "12px" },
                  sm: { fontSize: "14px" },
                  md: { fontSize: "16px" },
                }}
              />
            </Col>

            <Col
              xs={12}
              sm={12}
              md={12}
              className="d-flex flex-column align-items-center"
            >
              <Statistic
                title="Last Week Spots"
                value={spotsCounts?.lastWeekSpotCount}
                loading={statsLoadingTracker}
                responsive={{
                  xs: { fontSize: "12px" },
                  sm: { fontSize: "14px" },
                  md: { fontSize: "16px" },
                }}
              />

            </Col>
            <Col
              xs={12}
              sm={12}
              md={12}
              className="d-flex flex-column align-items-center"
            >
              <Statistic
                title="Lifetime Spots"
                value={spotsCounts?.total_served_count}
                loading={statsLoadingTracker}
                responsive={{
                  xs: { fontSize: "12px" },
                  sm: { fontSize: "14px" },
                  md: { fontSize: "16px" },
                }}
              />
            </Col>
          </Row>
        </div>

        <DateRangePickerFilter
          onChange={onDatePickerChange}
          datePickerError={datePickerError}
          dateString={dateString}
        />

        <div
          className="barChart"
          style={{ width: "100%", overflowX: "auto", overflowY: "scroll" }}
        >
          <DemoColumn
            lifeTimeViews={spotsGraph}
            startDate={startDate}
            endDate={endDate}
            chartLoadingTracker={chartLoadingTracker}
            chartDownloadData={chartDownloadData}
            setChartDownloadData={setChartDownloadData}
          />
        </div>
        {/* <div className="d-flex justify-content-end w-100 mt-4 mb-5">
          <Button className="downloadChart" onClick={downloadChart}>
            Download Report
          </Button>
        </div> */}

        {/* <div className="mt-5">
          <ViewsTable
            spotsDetails={spotsDetails}
            selectedCampaign={selectedCampaign}
            totalCount={totalItems}
            showDetails={showDetails}
            deliveredCampaignApi={deliveredCampaignApi}
            tableLoadingTracker={tableLoadingTracker}
          />
        </div> */}
      </div>
    </ViewsReportContainer>
  );
}

export default ViewsReport;
